import { render, staticRenderFns } from "./monitor.vue?vue&type=template&id=a0befb3c&scoped=true"
import script from "./monitor.vue?vue&type=script&lang=js"
export * from "./monitor.vue?vue&type=script&lang=js"
import style0 from "./monitor.vue?vue&type=style&index=0&id=a0befb3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0befb3c",
  null
  
)

export default component.exports